var map = {
	"./LPD.png": 58841,
	"./Worlds_2023.webp.png": 64455,
	"./adc.png": 32454,
	"./bot.png": 32070,
	"./fill.png": 57226,
	"./jungle.png": 94792,
	"./lolpredict/icons8-account-32.png": 97065,
	"./lolpredict/icons8-home-48.png": 8514,
	"./lolpredict/icons8-prediction-48.png": 16995,
	"./mid.png": 31273,
	"./opgg.png": 36375,
	"./rankIcons/BRONZE.png": 12148,
	"./rankIcons/CHALLENGER.png": 22945,
	"./rankIcons/DIAMONG.png": 73634,
	"./rankIcons/GOLD.png": 37998,
	"./rankIcons/GRANDMASTER.png": 27826,
	"./rankIcons/IRON.png": 82492,
	"./rankIcons/MASTER.png": 94299,
	"./rankIcons/PLATINUM.png": 76389,
	"./rankIcons/SILVER.png": 39682,
	"./support.png": 87194,
	"./teamImages/NoTeam.png": 10608,
	"./top.png": 41350,
	"./worlds.png": 51674,
	"./worldsblack.png": 24566,
	"./worldswhite.png": 43090,
	"./xura.png": 4060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57872;